import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const DomainForMigrationResponseSchema = z.object({
    id: z.string(),
    name: z.string(),
});
export class DomainForMigrationResponseDto extends createZodDto(DomainForMigrationResponseSchema) {
}
